var _circle, _circle2, _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalloweenScribbles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "url(#paint0_radial_420:66)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_420:66",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 111,
    height: 111
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#FFFBEB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_420:66)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6363 109.19C100.136 108.392 103.62 110.583 104.418 114.083C107.198 126.281 115.167 131.573 124.256 137.041C124.578 137.235 124.905 137.431 125.237 137.63C129.325 140.079 134.061 142.916 137.603 146.598C141.831 150.994 144.484 156.653 143.999 164.217C143.519 171.688 139.565 177.251 134.363 181.127C129.324 184.881 122.947 187.22 116.686 188.718C104.13 191.724 90.0244 191.81 82.2011 191.329C78.618 191.109 75.8921 188.025 76.1126 184.442C76.3331 180.859 79.4165 178.133 82.9995 178.354C90.1435 178.793 102.833 178.667 113.66 176.075C119.091 174.776 123.552 172.97 126.595 170.703C129.474 168.557 130.843 166.221 131.025 163.385C131.254 159.822 130.193 157.647 128.233 155.61C125.938 153.223 122.622 151.229 117.944 148.415C117.815 148.337 117.685 148.259 117.554 148.18C108.285 142.603 95.8249 134.885 91.7429 116.972C90.9453 113.472 93.1362 109.988 96.6363 109.19Z",
    fill: "url(#paint1_linear_420:66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8705 194.18L34.5058 198.018C34.5058 198.018 17.5435 179.272 19.018 156.143C20.9207 126.297 33.8784 62.7267 33.8784 62.7267L72.1647 60.0234C72.1647 60.0234 86.1895 106.514 95.1071 147.625C100.724 173.519 88.8705 194.18 88.8705 194.18Z",
    fill: "url(#paint2_linear_420:66)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.169 68.9329L70.1509 66.1805C70.1509 66.1805 81.6572 77.8204 82.812 94.1759C83.4549 103.281 89 116 78.8576 126.641L72.3199 186.485C75.6696 192.492 75.1703 193.491 73.0576 196.934L63.0296 197.642C60.6057 194.573 59.6564 193.046 63.3476 186.234C63.2432 182.54 63.1459 179.027 63.0528 175.665C62.7363 164.237 62.4683 154.557 62.1318 145.446C60.4512 145.87 58.798 146.179 57.3011 146.284C55.8151 146.389 54.1406 146.318 52.4179 146.139L56.6707 186.743C61.0044 191.666 60.2003 193.933 58.9575 197.437C58.897 197.608 58.8353 197.782 58.7732 197.959L49.9254 198.584C49.705 198.402 49.4942 198.233 49.2935 198.071C46.7465 196.021 45.8403 195.291 47.8486 188.396C46.965 184.808 46.1267 181.395 45.3245 178.129C40.9385 160.273 37.6314 146.809 33.8912 133.049C29.5699 122.892 23.6011 107.467 22.961 98.4018C22.2611 88.4894 31.169 68.9329 31.169 68.9329Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.396 43.4413C101.989 43.5322 102.84 45.3611 101.882 46.638L75.5904 81.6982C75.1886 82.2341 74.5452 82.5332 73.8765 82.4951L33.8342 80.2121C33.1451 80.1728 32.525 79.781 32.1936 79.1755L11.5397 41.4387C10.7858 40.0614 11.8404 38.3923 13.4079 38.4817L100.396 43.4413Z",
    fill: "#993030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1936 79.1755L30.8778 79.8957L32.1936 79.1755ZM75.5904 81.6982L74.3904 80.7983L75.5904 81.6982ZM101.882 46.638L100.682 45.7381L101.882 46.638ZM100.682 45.7381L74.3904 80.7983L76.7905 82.5982L103.082 47.5379L100.682 45.7381ZM73.9619 80.9975L33.9196 78.7145L33.7488 81.7096L73.7911 83.9926L73.9619 80.9975ZM33.5094 78.4554L12.8555 40.7185L10.2239 42.1588L30.8778 79.8957L33.5094 78.4554ZM13.3225 39.9793L100.311 44.9389L100.481 41.9438L13.4933 36.9841L13.3225 39.9793ZM12.8555 40.7185C12.667 40.3742 12.9307 39.9569 13.3225 39.9793L13.4933 36.9841C10.7501 36.8277 8.90468 39.7486 10.2239 42.1588L12.8555 40.7185ZM33.9196 78.7145C33.7473 78.7047 33.5923 78.6067 33.5094 78.4554L30.8778 79.8957C31.4577 80.9552 32.5429 81.6409 33.7488 81.7096L33.9196 78.7145ZM74.3904 80.7983C74.2899 80.9323 74.1291 81.007 73.9619 80.9975L73.7911 83.9926C74.9613 84.0594 76.0873 83.5359 76.7905 82.5982L74.3904 80.7983ZM103.082 47.5379C104.758 45.3034 103.27 42.1027 100.481 41.9438L100.311 44.9389C100.709 44.9616 100.922 45.4188 100.682 45.7381L103.082 47.5379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_420:66)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3306 30.9231C89.0909 29.5871 68.5921 39.9945 68.5921 39.9945C65.8071 38.5071 62.9456 37.2866 60.2452 36.6577C55.8778 35.6405 50.578 35.8553 45.5404 36.5619C45.5404 36.5619 29.6702 21.7335 27.4987 22.8639C25.3273 23.9942 27.6941 42.5071 27.6941 42.5071L25.829 64.3858C27.3884 76.1319 50.0339 87.739 50.0339 87.739C50.0339 87.739 74.2811 85.4984 79.7538 75.6156L84.7414 53.86C84.7414 53.86 93.5702 32.2591 91.3306 30.9231Z",
    fill: "url(#paint3_linear_420:66)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.1445 63.3114C48.339 66.066 45.9115 63.4691 43.1569 63.6636C40.4024 63.8581 38.3639 66.7703 38.1694 64.0157C37.9749 61.2612 40.1559 60.3667 42.9104 60.1723C45.665 59.9778 47.95 60.5568 48.1445 63.3114Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0524 69.043C67.9642 71.581 66.995 68.1608 64.457 67.0726C61.919 65.9844 58.7734 67.6402 59.8616 65.1023C60.9498 62.5643 63.2983 62.7677 65.8362 63.8559C68.3742 64.9441 70.1406 66.505 69.0524 69.043Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2181 75.9526C52.5589 76.5029 53.3247 76.5895 53.7796 76.1291L57.2076 72.6605C57.7944 72.0667 57.4382 71.0577 56.6086 70.9639L50.6135 70.2863C49.7839 70.1925 49.2114 71.0965 49.6509 71.8064L52.2181 75.9526Z",
    fill: "#C5AAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.397 47.9893L64.2669 37.3355L68.6364 39.7334L62.397 47.9893Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4194 46.067L45.2206 36.0985L50.1925 35.7474L49.4194 46.067Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4015 58.7856L62.5257 37.5757C62.5257 37.5757 59.5742 36.2685 57.3973 35.9328C55.2203 35.5972 51.3769 35.8566 51.3769 35.8566L54.4015 58.7856Z",
    fill: "#676767"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9178 82.8751L46.5378 78.4543L49.8595 78.6706L47.9178 82.8751Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9178 82.8751L46.5378 78.4543L49.8595 78.6706L47.9178 82.8751Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7097 83.8145L55.5077 79.4407L58.469 79.6336L56.7097 83.8145Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7097 83.8145L55.5077 79.4407L58.469 79.6336L56.7097 83.8145Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7745 69.9648C24.6287 69.0084 25.7906 68.423 26.4725 69.1093L36.1299 78.8302C36.6091 79.3126 36.4776 80.1222 35.8704 80.4281L28.2777 84.2534C27.6705 84.5593 26.9417 84.1831 26.8392 83.511L24.7745 69.9648Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1478 74.3656C83.8808 73.7341 84.9939 74.4078 84.7744 75.35L81.6665 88.6955C81.5123 89.3577 80.7565 89.6763 80.1748 89.3242L72.9013 84.9223C72.3196 84.5702 72.2512 83.7529 72.7664 83.3091L83.1478 74.3656Z",
    fill: "black"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_420:66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.9138 79.0883C52.1316 80.0546 50.6962 80.657 49.0906 80.5655C46.7353 80.4313 44.9056 78.8548 45.0038 77.0443C45.102 75.2338 47.0909 73.8749 49.4462 74.0091C51.0519 74.1006 52.4134 74.8624 53.0862 75.9117C53.8684 74.9454 55.3038 74.343 56.9094 74.4345C59.2647 74.5687 61.0944 76.1452 60.9962 77.9557C60.898 79.7662 58.9091 81.1251 56.5538 80.9909C54.9481 80.8994 53.5866 80.1376 52.9138 79.0883Z",
    fill: "#8A8A8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_420:66",
    x: 21.829,
    y: 18.8024,
    width: 73.8655,
    height: 72.9366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_420:66"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_420:66",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_420:66",
    x: 44,
    y: 74,
    width: 18,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_420:66"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_420:66",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_420:66",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.5 55.5) rotate(90) scale(55.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#A4633F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_420:66",
    x1: 95.6675,
    y1: 109.411,
    x2: 78.1996,
    y2: 183.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_420:66",
    x1: 54.4631,
    y1: 110.207,
    x2: 60.3262,
    y2: 196.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_420:66",
    x1: 55.5941,
    y1: 33.938,
    x2: 51.0242,
    y2: 89.8988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalloweenScribbles);
export default __webpack_public_path__ + "static/media/halloween-scribbles.a57f5881696be8decad1bc60f871fbcd.svg";
export { ForwardRef as ReactComponent };